import { Component, OnInit } from '@angular/core';
import { DataService } from '../services/data.service';
import { environment } from 'src/environments/environment';
import {AnalyticsService} from "../analytics.service";

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.css']
})
export class ErrorPageComponent implements OnInit {

  errorMessage: any;
  errorDescription: any;

  constructor(public dataService: DataService,
              private analyticsService: AnalyticsService) {
    this.errorMessage = this.dataService.getErrorMessage();
    this.errorDescription = this.dataService.getErrorDescription();
    console.log("Error Message", this.errorMessage)
    console.log("Error Description", this.errorDescription)
  }

  ngOnInit() {
  }

  public openMobileApp(bannerImage: string) {
    this.analyticsService.logEvent(bannerImage)
    window.open(environment.appDownloadCardDynamicLink, "appDownloadCardDynamicLink");
  }
}
